import type { Dispatch, SetStateAction } from "react";

export function applyVisitorConsentDocumentCheckboxChange(params: {
  currentDocument: { id: string } | null | undefined;
  checked: boolean;
  setDocumentConsents: Dispatch<SetStateAction<Record<string, boolean>>>;
}): void {
  const { currentDocument, checked, setDocumentConsents } = params;
  if (!currentDocument) {
    return;
  }
  setDocumentConsents(prev => ({
    ...prev,
    [currentDocument.id]: checked
  }));
}
